import React from "react";

import money from "astrid-helpers/src/money";

import LoadingContext from "../../../ui/components/LoadingContext/LoadingContext";
import Table from "../../../ui/components/Table/Table";

import useFinalizedCostsTableColumns from "./hooks/useFinalizedCostsTableColumns";

export default function FinalizedCostsTable({ costs, partyId, currency, totalFinalizedAmount }) {
	const finalizedCostsColumns = useFinalizedCostsTableColumns({ partyId });

	return (
		<LoadingContext data={costs}>
			<Table data={costs} columns={finalizedCostsColumns} footer={false}>
				<Table.Row textAlign={"right"} style={{ fontWeight: "bold" }}>
					<Table.Cell></Table.Cell>
					<Table.Cell></Table.Cell>
					<Table.Cell></Table.Cell>
					<Table.Cell></Table.Cell>
					<Table.Cell></Table.Cell>
					<Table.Cell>{money(totalFinalizedAmount, currency)}</Table.Cell>
					<Table.Cell></Table.Cell>
				</Table.Row>
			</Table>
		</LoadingContext>
	);
}
